import { Box, TextField, Typography } from '@mui/material'
import React from 'react'
import { InputLabelStyled } from './PresentingComplaintSection'
import { riskRatingOpt } from './formOptions'
import RadioButtonController, { CheckBoxLikeRadio } from '../../../../components/RadioButtonController/RadioButtonController'
import { ParentContainerSection } from '../DiabeticForm'

const SummaryDiabetic = (props) => {
    const {control, errors, getValues} = props
  return (
    <>
        <ParentContainerSection  heading="Section H - Summary Risk Rating for Diabetic Retionopathy">
               
               <Box sx={{ display: "flex", gap: "0.5rem",}}>
               <InputLabelStyled >Risk Rating</InputLabelStyled>
               <Box sx={{ display: "flex", flexDirection: "column", gap: "0.1rem", }}>
                      <CheckBoxLikeRadio
                                    name="risk_rating"
                                    control={control}
                                    errors={errors}
                                    options={riskRatingOpt}
                                    isRow={false}
                                    isDisabled={true}
                            />
            </Box>
               </Box>
            
    
            <Box sx={{ display: "flex", gap: "1rem", alignItems: "center", my: "1rem"  }}>
                    <InputLabelStyled>Comments</InputLabelStyled>
                        <TextField
                            id="diabetic_comments"
                            label="Comments"
                            multiline
                            disabled
                            rows={2}
                            defaultValue={getValues("diabetic_comments")}
                            sx={{flexBasis: "792px",  "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: (theme)=>theme.palette.black.main,
        },
        "& .MuiInputLabel-root.Mui-disabled":{
          color:(theme)=>theme.palette.black.main
        }}}
                            inputProps={{
                                style:{
                                    width: "100%"
                                }
                            }}
                        />
                </Box>

        </ParentContainerSection>
    </>
  )
}

export default SummaryDiabetic